import { Directive, ElementRef, EventEmitter, Input, OnChanges, Output, Renderer2 } from '@angular/core';
import { PermissionsService } from 'app/core/services';
import { BaseEntity } from 'app/model';

@Directive({
  selector: '[permissions]',
})
export class PermissionsDirective implements OnChanges {
  @Input() permissions: string | string[];
  @Input() permissionsModel: BaseEntity;
  @Input() useHide: boolean;

  constructor(private el: ElementRef, private permissionsService: PermissionsService, private renderer: Renderer2) {}

  ngOnChanges(): void {
    const permissions = this.parsePermissions(this.permissions);
    this.evalPermissions(permissions);
  }

  private parsePermissions(permissions: string | string[]): string[] {
    if (!Array.isArray(permissions)) {
      return permissions.split(',').map((permission) => permission.trim());
    }

    return permissions
      .map((permission) => this.parsePermissions(permission))
      .reduce((prev, cur) => [...prev, ...cur], []);
  }

  private evalPermissions(requiredPermissions: string[]): void {
    // Hide / disable initially to prevent showing then removing elements if the user doesn't have permissions
    this.hideOrDisable();
    this.permissionsService.getPermissions(this.permissionsModel).subscribe((permissions) => {
      if (!permissions || requiredPermissions.every((permission) => permissions.includes(permission))) {
        this.showOrEnable();
      } else {
        this.hideOrDisable();
      }
    });
  }

  private hideOrDisable(): void {
    if (this.useHide) {
      this.renderer.addClass(this.el.nativeElement, 'hidden');
    } else {
      this.el.nativeElement.disabled = true;
      // For elements that can't be disabled through disabled=true, set the attribute directly
      if (!this.el.nativeElement.getAttribute('disabled')) {
        this.el.nativeElement.setAttribute('disabled', true);
      }
    }
  }

  private showOrEnable(): void {
    if (this.useHide) {
      this.renderer.removeClass(this.el.nativeElement, 'hidden');
    } else {
      this.el.nativeElement.disabled = false;
      if (this.el.nativeElement.getAttribute('disabled')) {
        this.el.nativeElement.removeAttribute('disabled');
      }
    }
  }
}
